<!--NOTE: 
  Angular loads the child tree regardless of parent data, which casues data to not show later on,
  so to tackle this, we have to add the planType check -->
<div>
  <div *ngIf="planType === 'planAvailable'">
    <app-gdo-subscription-detail
      [acctDetail]="acctDetail"
      [selectedSP]="selectedSP"
      [termsAndConditionStatus]="termsAndConditionStatus"
    >
    </app-gdo-subscription-detail>
  </div>
  <!-- <div *ngIf=" planType === 'noPlanAvailable'">
    <h3>No Active Palns Found</h3>
  </div> -->
</div>
